(function (jQuery, Drupal) {

  var once = true;
  Drupal.behaviors.slider = {
    attach: function (context, settings) {
      if (once) {
        once = false;

        var $images1 = jQuery('.paragraph--type--image');
        $images1.each(function (index, element) {
          var $element = jQuery(element);
          if ($element.find('.field--name-field-image > .field__item').length > 1) {
            $element.find('.field--name-field-image').slick({
              'autoplay': true,
              'dots': true,
            });
          }
        });

        var $slider1 = jQuery('.field--name-field-product-variations > .field__item > .slider');
        if ($slider1.find('.slides').length > 0) {
          $slider1.find('.slides').slick({
            'autoplay': true,
            'dots': true,
          });

          var startNavIndex = $slider1.find('.navs .nav').length - $slider1.find('.slides .slide:not(.slick-cloned)').length;
          $slider1.find('.navs .nav').each(function (index, element) {
            var $element = jQuery(element);
            $element.click(function (event) {
              $slider1.find('.slides').slick('slickGoTo', startNavIndex + index);
            });
          });
        }

        var $images2 = jQuery('article.node--type-production.node--view-mode-full');
        if ($images2.find('.field--name-field-production-images > .field__item').length > 1) {
          var $items = $images2.find('.field--name-field-production-images');
          $items.slick({
            'autoplay': true,
            'dots': true,
          });
        }

        var $slider2 = jQuery('.field--name-field-project-guide-advice > .field__item > .slider');
        $slider2.find('.navs .nav').each(function (index, element) {
          var $element = jQuery(element);
          $element.click(function (event) {
            $slider2.find('.slides .slides-inner').slick('slickGoTo', index);
            jQuery(window).scrollTop($slider2.find('.slides').offset().top);
          });
        });
        $slider2.find('.slides .slides-inner .slide .prev').click(function () {
          $slider2.find('.slides .slides-inner').slick('slickPrev');
        });
        $slider2.find('.slides .slides-inner .slide .next').click(function () {
          $slider2.find('.slides .slides-inner').slick('slickNext');
        });
        $slider2.find('.slides .slides-inner').slick({
          'arrows': false,
        });
        $slider2.find('.slides .slides-inner').on('afterChange', function(event, slick, currentSlide){
          window.location.hash = 'slide-' + currentSlide;
        });
        if (window.location.hash && /^#slide-[0-9]{1}$/.test(window.location.hash)) {
          var slideNumber = window.location.hash.replace('#slide-', '');
          $slider2.find('.slides .slides-inner').slick('slickGoTo', slideNumber);
        }
      }
    }
  };

})(jQuery, Drupal);
